/**
 * A new item's first document: its name and what every save needs. A title starts without a
 * video (a draft may be saved before it has one); its kind follows the brand's business. Pure.
 */

import type { EntityType } from "../api/admin";

export function blankEntity(type: EntityType, id: string, locale: string, name = "", titleKind = "film"): Record<string, unknown> {
  const named = { id, title: { [locale]: name } };
  switch (type) {
    case "title": return { ...named, kind: titleKind, artwork: {}, entitlement: { access: "free" } };
    case "series": return { ...named, kind: titleKind === "class" ? "programme" : titleKind === "lesson" ? "course" : "series", artwork: {}, entitlement: { access: "free" }, seasons: [] };
    case "liveEvent": return { ...named, artwork: {}, startsAt: new Date(Math.ceil((Date.now() + 86_400_000) / 3_600_000) * 3_600_000).toISOString(), entitlement: { access: "free" } };
    case "collection": return { ...named, layout: "row", itemIds: [] };
    case "page": return { ...named, rails: [] };
    case "person": return { id, name };
    case "taxonomy": return { ...named, terms: [] };
    case "stage": return { ...named };
  }
}
